var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-field-v"},[(_vm.fieldViewContainer)?[_c(_vm.fieldViewContainer,_vm._b({tag:"component"},'component',_vm.$attrs,false))]:[_c('div',{staticClass:"not-supported-type"},[_c('span',[_vm._v("不支持的字段类型")]),_vm._v(" "),(_vm.type)?_c('span',[_vm._v("["+_vm._s(_vm.type)+"]")]):_vm._e()])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }